import { render } from "./ScoresContainer.vue?vue&type=template&id=43026572"
import script from "./ScoresContainer.vue?vue&type=script&lang=ts"
export * from "./ScoresContainer.vue?vue&type=script&lang=ts"
script.render = render

export default script